module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Templates',
      "size": 'md',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "px-7 py-3 flex-grow overflow-auto"
  }, [_c('div', {
    staticClass: "mb-3 flex items-center justify-between space-x-1 rounded p-1.5 bg-trueGray-100 border border-solid border-gray-200"
  }, [_c('div', [_c('button', {
    staticClass: "font-medium",
    class: _vm.saved_feedback_is_selected ?
      'rounded border border-solid border-gray-200 bg-white py-2 px-3 ' :
      'pl-3',
    on: {
      "click": function($event) {
        _vm.saved_feedback_is_selected = true
      }
    }
  }, [_vm._v("\n          Saved Feedback\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "font-medium",
    class: !_vm.saved_feedback_is_selected ?
      'rounded border border-solid border-gray-200 bg-white py-2 px-3' :
      'pl-3',
    on: {
      "click": function($event) {
        _vm.saved_feedback_is_selected = false
      }
    }
  }, [_vm._v("\n          Suggested Feedback\n        ")])]), _vm._v(" "), _c('div', [(_vm.saved_feedback_is_selected) ? _c('button', {
    staticClass: "sample mr-2 px-5 py-1.5 cursor-pointer text-xs font-semibold text-white bg-blueGray-500 rounded",
    on: {
      "click": _vm.newSavedFeedback
    }
  }, [_c('span', [_vm._v("New")])]) : _vm._e(), _vm._v(" "), (_vm.saved_feedback_is_selected) ? _c('button', {
    staticClass: "sample mr-2 px-5 py-1.5 cursor-pointer text-xs font-semibold text-white bg-blueGray-500 rounded",
    on: {
      "click": _vm.showImportFeedback
    }
  }, [_c('span', [_vm._v("Import")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sample mr-2 px-5 py-1.5 cursor-pointer text-xs font-semibold text-white bg-blueGray-500 rounded",
    on: {
      "click": _vm.refresh
    }
  }, [_c('i', {
    staticClass: "fas fa-sync",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), (_vm.saved_feedback_is_selected) ? _c('div', [(_vm.saved_feedback_to_display.length) ? _c('div', _vm._l((_vm.saved_feedback_to_display), function(feedback, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-3 rounded border border-solid border-gray-200 bg-gray-100 relative"
    }, [_c('div', {
      staticClass: "font-medium py-2.5 pl-2.5 pr-5 break-all"
    }, [_vm._v("\n            " + _vm._s(feedback.text) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "border-t"
    }), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end px-2.5 py-2"
    }, [_c('button', {
      staticClass: "sample py-1 px-2 rounded bg-primary text-white text-xs font-semibold",
      on: {
        "click": function($event) {
          return _vm.selectSavedFeedback(feedback)
        }
      }
    }, [_vm._v("\n              Add Feedback\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "absolute top-2.5 right-2.5"
    }, [_c('v-dropdown', {
      attrs: {
        "placement": "right"
      },
      scopedSlots: _vm._u([{
        key: "button",
        fn: function() {
          return [_c('i', {
            staticClass: "fas fa-ellipsis-v cursor-pointer text-gray-500 w-full flex items-center justify-end text-md"
          })]
        },
        proxy: true
      }, {
        key: "content",
        fn: function() {
          return [_c('ul', {
            staticClass: "w-28"
          }, [_c('li', {
            staticClass: "sample group px-3 py-2 rounded-t flex items-center w-full h-9 cursor-pointer hover:bg-gray-100",
            on: {
              "click": function($event) {
                return _vm.editSavedFeedback(feedback)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-edit",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "mx-3 text-xs"
          }, [_vm._v(" Edit")])]), _vm._v(" "), _c('li', {
            staticClass: "sample group px-3 py-2 rounded-b flex items-center w-full h-9 cursor-pointer hover:bg-gray-100 text-red-600",
            on: {
              "click": function($event) {
                return _vm.deleteSavedFeedback(feedback)
              }
            }
          }, [_c('i', {
            staticClass: "text-red-500 fas fa-trash-alt"
          }), _vm._v(" "), _c('span', {
            staticClass: "mx-3 text-xs px-1"
          }, [_vm._v(" Delete")])])])]
        },
        proxy: true
      }], null, true)
    })], 1)])
  }), 0) : _c('div', [_vm._v("\n        You have no saved feedback templates. Create a new template or import\n        some from an existing course.\n      ")])]) : _c('div', _vm._l((_vm.automated_feedback_to_display), function(feedback, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-3 rounded border border-solid border-gray-200 bg-gray-100"
    }, [_c('div', {
      staticClass: "font-medium p-2.5"
    }, [_vm._v(_vm._s(feedback.text))]), _vm._v(" "), _c('button', {
      directives: [{
        name: "my-tooltip",
        rawName: "v-my-tooltip",
        value: ({
          content: feedback.explanation,
          placement: 'right',
        }),
        expression: "{\n            content: feedback.explanation,\n            placement: 'right',\n          }"
      }],
      staticClass: "pl-2.5 pb-2.5 text-pinky"
    }, [_vm._v("\n          Why this suggestion?\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "border-t"
    }), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end px-2.5 py-2"
    }, [_c('button', {
      staticClass: "sample py-1 px-2 rounded bg-primary text-white text-xs font-semibold",
      on: {
        "click": function($event) {
          return _vm.selectAutomatedFeedback(feedback)
        }
      }
    }, [_vm._v("\n            Add Feedback\n          ")])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7d8b1a00!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/templatesModal.vue
// module id = 1264
// module chunks = 61